import React, { Component } from "react"
import styled from "styled-components"
import { SECONDARY_TEXT, ACTIVE_TEXT, TINY_SHADOW } from "./consts/colors"
import Carousel from "re-carousel"
import IndicatorDots from "./IndicatorDots"
import Icon from "./Icons"
import Fathom from "../assets/Fathom.png"
import Whale from "../assets/whale.png"

const CarouselData = {
  FrameOneBackground: { Fathom },
  FrameOneQuote:
    "'Cool people saying something cool about how great TinyMerch is. And how because of TinyMerch they are able to take a 360 day vacation to Ibza.'",
  FrameOneAvatar: { Whale },
  FrameOneAuthor: "Matthew Smith | Director",
  FrameOneLinkCopy: "See the Fathom & Draft Store",
  FrameOneLinkUrl: "#",

  FrameTwoBackground: { Fathom },
  FrameTwoQuote:
    "Cool people saying something cool about how great TinyMerch is. And how because of TinyMerch they are able to take a 360 day vacation to Ibza.",
  FrameTwoAvatar: { Whale },
  FrameTwoAuthor: "Matthew Smith | Director",
  FrameTwoLinkCopy: "See the Fathom & Draft Store",
  FrameTwoLinkUrl: "#",

  FrameThreeBackground: { Fathom },
  FrameThreeQuote:
    "'Cool people saying something cool about how great TinyMerch is. And how because of TinyMerch they are able to take a 360 day vacation to Ibza.'",
  FrameThreeAvatar: { Whale },
  FrameThreeAuthor: "Matthew Smith | Director",
  FrameThreeLinkCopy: "See the Fathom & Draft Store",
  FrameThreeLinkUrl: "#"
}
const CarouselWrapper = styled.div`
  display: flex;
  height: 600px;
  width: 100%;
  margin: 50px 0px;

  @media screen and (max-width: 768px) {
    height: 500px;
    margin: 25px 0px;
  }

  @media screen and (max-width: 615px) {
    position: relative;
    top: -50px;
    height: 250px;
    margin: 10px 0px;
  }
`

const CarouselSlide = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const CarouselImg = styled.img`
  position: relative;
  width: 70%;
  max-width: 800px;
  box-shadow: 0px 4px 10px ${TINY_SHADOW};
  border-radius: 8px;

  @media screen and (max-width: 768px) {
    width: 80%;
    top: -5%;
  }

  @media screen and (max-width: 615px) {
    display: none;
    top: -27%;
    width: 90%;
  }
`
const CarouselCard = styled.div`
  position: absolute;
  right: 15%;
  top: 42%;
  display: flex;
  flex-direction: column;
  padding: 25px 15px;
  width: 50%;
  max-width: 450px;
  background-color: white;
  box-shadow: 0px 4px 8px ${TINY_SHADOW};
  border-radius: 8px;

  @media screen and (max-width: 1400px) {
    right: 10%;
  }

  @media screen and (max-width: 768px) {
    right: 5%;
    top: 50%;
  }

  @media screen and (max-width: 615px) {
    width: 100%;
    left: 0%;
    top: 0%;
    position: relative;
    justify-content: center;
  }
`

const Quote = styled.p`
  font-size: 20px;
  line-height: 28px;
  margin-bottom: 25px;

  @media screen and (max-width: 768px) {
    font-size: 17px;
    line-height: 22px;
    margin-bottom: 10px;
  }
`

const Author = styled.p`
  font-size: 15px;
  color: ${SECONDARY_TEXT};
`

const Avatar = styled.img`
  border-radius: 20px;
  width: 15px;
  height: 15px;
  margin-right: 15px;
`

const CarouselLink = styled.a`
  display: flex;
  align-items: center;
  font-size: 17px;
  div {
    position: relative;
    top: 2px;
    padding-left: 10px;
  }
`

const CarouselContainer = props => (
  <CarouselWrapper>
    <Carousel loop auto widgets={[IndicatorDots]}>
      <CarouselSlide style={{ height: "100%" }}>
        <CarouselImg src={Fathom} />
        <CarouselCard>
          <Quote>{CarouselData.FrameOneQuote}</Quote>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Avatar src={Whale} />
            <Author>{CarouselData.FrameOneAuthor}</Author>
          </div>
          <div>
            <CarouselLink href={CarouselData.FrameOneLinkUrl}>
              {CarouselData.FrameOneLinkCopy}
              <Icon name="forward" />
            </CarouselLink>
          </div>
        </CarouselCard>
      </CarouselSlide>
      <CarouselSlide style={{ height: "100%" }}>
        <CarouselImg src={Fathom} />
        <CarouselCard>
          <Quote>{CarouselData.FrameOneQuote}</Quote>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Avatar src={Whale} />
            <Author>{CarouselData.FrameOneAuthor}</Author>
          </div>
          <div>
            <CarouselLink href={CarouselData.FrameOneLinkUrl}>
              {CarouselData.FrameOneLinkCopy}
              <Icon name="forward" />
            </CarouselLink>
          </div>
        </CarouselCard>
      </CarouselSlide>
      <CarouselSlide style={{ height: "100%" }}>
        <CarouselImg src={Fathom} />
        <CarouselCard>
          <Quote>{CarouselData.FrameOneQuote}</Quote>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Avatar src={Whale} />
            <Author>{CarouselData.FrameOneAuthor}</Author>
          </div>
          <div>
            <CarouselLink href={CarouselData.FrameOneLinkUrl}>
              {CarouselData.FrameOneLinkCopy}
              <Icon name="forward" />
            </CarouselLink>
          </div>
        </CarouselCard>
      </CarouselSlide>
    </Carousel>
  </CarouselWrapper>
)

export default CarouselContainer



// WEBPACK FOOTER //
// ./src/components/Carousel.js